import React from "react";
import FooterSection from "../FooterView/Section/FooterSection";


type includeFooterProps = {
    children: any
}
class IncludeFooterView extends React.Component<includeFooterProps> {

    render(){
        const { children } = this.props
        return <div className="page-with-footer">
            {children}
            <FooterSection/>
        </div>
    }
}

export { IncludeFooterView }